/* Diver Bubbles — homepage interactions */
(function () {
  if (window.__dbHome) return;
  window.__dbHome = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(pointer: fine)').matches;

  function revealAllNow() {
    document.querySelectorAll('.db-reveal:not(.is-inview)').forEach(function (el) {
      el.classList.add('is-inview');
    });
  }

  function init() {
    try {
      /* Hero background video — injected only when allowed (desktop by default) */
      document.querySelectorAll('.db-hero__media[data-db-video]').forEach(function (media) {
        if (media.dataset.dbVideoBound) return;
        media.dataset.dbVideoBound = '1';
        if (reduced) return;
        var allowMobile = media.getAttribute('data-db-video-mobile') === 'true';
        if (!allowMobile && window.innerWidth < 990) return;
        var v = document.createElement('video');
        v.className = 'db-hero__bg db-hero__bg--video';
        v.autoplay = true;
        v.muted = true;
        v.loop = true;
        v.playsInline = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('aria-hidden', 'true');
        var img = media.querySelector('img.db-hero__bg');
        if (img && (img.currentSrc || img.src)) v.poster = img.currentSrc || img.src;
        var s = document.createElement('source');
        s.src = media.getAttribute('data-db-video');
        s.type = 'video/mp4';
        v.appendChild(s);
        var scrim = media.querySelector('.db-hero__scrim');
        media.insertBefore(v, scrim);
        v.addEventListener('canplay', function () { v.classList.add('is-playing'); });
        var pl = v.play();
        if (pl && pl.catch) pl.catch(function () {});
      });

      /* Hero load choreography */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          document.querySelectorAll('.db-hero').forEach(function (el) {
            el.classList.add('is-loaded');
          });
        });
      });

      /* Liquid hero CTAs — inject a gooey droplet layer (SVG #db-goo filter)
         that rises from the top edge on hover; styling in db-mega.css */
      if (!reduced) {
        var heroLiquidBtns = document.querySelectorAll('.db-hero .db-btn');
        if (heroLiquidBtns.length && !document.getElementById('db-goo-defs')) {
          var dbGooSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          dbGooSvg.setAttribute('id', 'db-goo-defs');
          dbGooSvg.setAttribute('aria-hidden', 'true');
          dbGooSvg.setAttribute('width', '0');
          dbGooSvg.setAttribute('height', '0');
          dbGooSvg.innerHTML = '<defs><filter id="db-goo" x="-20%" y="-130%" width="140%" height="280%"><feGaussianBlur in="SourceGraphic" stdDeviation="5" result="b"/><feColorMatrix in="b" mode="matrix" values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 18 -8" result="g"/><feBlend in="SourceGraphic" in2="g"/></filter></defs>';
          document.body.appendChild(dbGooSvg);
        }
        heroLiquidBtns.forEach(function (btn) {
          if (btn.dataset.dbLiquid) return;
          btn.dataset.dbLiquid = '1';
          var goo = document.createElement('span');
          goo.className = 'db-liquid__goo';
          goo.setAttribute('aria-hidden', 'true');
          for (var di = 0; di < 6; di++) goo.appendChild(document.createElement('i'));
          var txt = document.createElement('span');
          txt.className = 'db-liquid__text';
          while (btn.firstChild) txt.appendChild(btn.firstChild);
          btn.appendChild(goo);
          btn.appendChild(txt);
          btn.classList.add('db-liquid');
        });
      }

      /* Immersive hero — drifting marine-snow particles on a canvas */
      document.querySelectorAll('canvas[data-db-particles]').forEach(function (canvas) {
        if (canvas.dataset.dbPartBound) return;
        canvas.dataset.dbPartBound = '1';
        var ctx = canvas.getContext && canvas.getContext('2d');
        if (!ctx) return;
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var w = 0, h = 0, particles = [];
        var count = reduced ? 40 : (window.innerWidth < 750 ? 90 : 220);
        var ro = null, io = null, onScrollStir = null, onPointerMove = null, stir = 0, mouseX = -9999, mouseY = -9999;

        var rnd = function () { return Math.random(); };
        var seed = function () {
          particles = [];
          for (var i = 0; i < count; i++) {
            particles.push({
              x: rnd(), y: rnd(),
              r: 0.4 + rnd() * rnd() * 2.4,
              a: 0.12 + rnd() * 0.5,
              vy: 0.015 + rnd() * 0.05,
              sway: 0.2 + rnd() * 0.8,
              phase: rnd() * 6.283,
              ox: 0, oy: 0
            });
          }
        };
        var resize = function () {
          var rect = canvas.getBoundingClientRect();
          w = rect.width; h = rect.height;
          if (w <= 0 || h <= 0) return;
          canvas.width = Math.round(w * dpr);
          canvas.height = Math.round(h * dpr);
          ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        };
        var draw = function (animated, dt) {
          if (w <= 0 || h <= 0) return;
          if (animated && stir > 0.001) stir -= stir * Math.min(dt * 1.0, 0.5);
          var swayAmp = 8 + stir * 28;
          ctx.clearRect(0, 0, w, h);
          for (var i = 0; i < particles.length; i++) {
            var p = particles[i];
            if (animated) {
              p.y -= p.vy * dt * (1 + stir * 1.0);
              p.phase += dt * p.sway * (1 + stir * 1.4);
              if (p.y < -0.02) { p.y = 1.02; p.x = rnd(); }
            }
            var px = p.x * w + Math.sin(p.phase) * swayAmp + Math.sin(p.y * 5 + p.phase) * stir * 9;
            var py = p.y * h;
            if (animated) {
              /* Repel from the cursor, then ease back */
              var tox = 0, toy = 0;
              var dxm = px - mouseX, dym = py - mouseY;
              var dm2 = dxm * dxm + dym * dym;
              if (dm2 < 14400) {
                var dm = Math.sqrt(dm2) || 1;
                var force = (1 - dm / 120) * 46;
                tox = (dxm / dm) * force;
                toy = (dym / dm) * force;
              }
              p.ox += (tox - p.ox) * Math.min(dt * 8, 1);
              p.oy += (toy - p.oy) * Math.min(dt * 8, 1);
              px += p.ox;
              py += p.oy;
            }
            if (p.r > 1.6) {
              ctx.beginPath();
              ctx.arc(px, py, p.r * 2.6, 0, 6.283);
              ctx.fillStyle = 'rgba(150, 210, 255, ' + (p.a * 0.14).toFixed(3) + ')';
              ctx.fill();
            }
            ctx.beginPath();
            ctx.arc(px, py, p.r, 0, 6.283);
            ctx.fillStyle = 'rgba(190, 228, 255, ' + p.a.toFixed(3) + ')';
            ctx.fill();
          }
        };
        var teardown = function () {
          if (ro) { ro.disconnect(); ro = null; }
          if (io) { io.disconnect(); io = null; }
          if (onScrollStir) { window.removeEventListener('scroll', onScrollStir); onScrollStir = null; }
          if (onPointerMove) { window.removeEventListener('pointermove', onPointerMove); onPointerMove = null; }
        };

        seed();
        resize();

        if (reduced) {
          draw(false, 0);
          /* ResizeObserver re-sizes on late layout and self-cleans when the section is replaced */
          if ('ResizeObserver' in window) {
            ro = new ResizeObserver(function () {
              if (!canvas.isConnected) { teardown(); return; }
              resize(); draw(false, 0);
            });
            ro.observe(canvas);
          }
          return;
        }

        var running = false, visible = true, last = 0;
        /* Scroll stirs the water: velocity adds turbulence that decays */
        var lastSY = window.scrollY || 0;
        onScrollStir = function () {
          var y = window.scrollY || 0;
          stir = Math.min(stir + Math.abs(y - lastSY) * 0.035, 6);
          lastSY = y;
        };
        window.addEventListener('scroll', onScrollStir, { passive: true });
        /* Particles part around the cursor */
        if (finePointer) {
          onPointerMove = function (e) {
            var rect = canvas.getBoundingClientRect();
            mouseX = e.clientX - rect.left;
            mouseY = e.clientY - rect.top;
          };
          window.addEventListener('pointermove', onPointerMove, { passive: true });
        }
        var frame = function (now) {
          if (!canvas.isConnected) { teardown(); running = false; return; }
          if (!last) last = now;
          var dt = Math.min((now - last) / 1000, 0.05);
          last = now;
          draw(true, dt);
          if (running && visible) requestAnimationFrame(frame);
          else running = false;
        };
        var start = function () {
          if (running) return;
          resize();
          running = true; last = 0;
          requestAnimationFrame(frame);
        };
        if ('ResizeObserver' in window) {
          ro = new ResizeObserver(function () {
            if (!canvas.isConnected) { teardown(); return; }
            resize();
          });
          ro.observe(canvas);
        }
        if ('IntersectionObserver' in window) {
          io = new IntersectionObserver(function (entries) {
            visible = entries[0].isIntersecting;
            if (visible) start();
          }, { threshold: 0 });
          io.observe(canvas);
        } else {
          start();
        }
      });

      /* Scroll reveals — with support guard so nothing is stranded invisible */
      if (!('IntersectionObserver' in window)) {
        revealAllNow();
      } else {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('is-inview');
              io.unobserve(e.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
        document.querySelectorAll('.db-reveal:not(.is-inview)').forEach(function (el) {
          io.observe(el);
        });
      }

      /* Count-up numbers */
      var easeOut = function (t) { return 1 - Math.pow(1 - t, 4); };
      if ('IntersectionObserver' in window) {
        var cio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            cio.unobserve(e.target);
            var el = e.target;
            var target = parseFloat(el.getAttribute('data-db-count') || '0');
            if (reduced) { el.textContent = target; return; }
            var t0 = performance.now();
            var dur = 1600;
            var tick = function (now) {
              var pp = Math.min((now - t0) / dur, 1);
              el.textContent = Math.round(target * easeOut(pp));
              if (pp < 1) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
          });
        }, { threshold: 0.6 });
        document.querySelectorAll('[data-db-count]').forEach(function (el) {
          if (el.dataset.dbCountBound) return;
          el.dataset.dbCountBound = '1';
          if (!reduced) el.textContent = '0';
          cio.observe(el);
        });
      }

      /* Parallax (decorative images only) */
      if (!reduced) {
        var els = Array.prototype.slice.call(document.querySelectorAll('[data-db-parallax]'));
        if (els.length && !document.documentElement.dataset.dbParallaxBound) {
          document.documentElement.dataset.dbParallaxBound = '1';
          var ticking = false;
          var update = function () {
            ticking = false;
            var vh = window.innerHeight;
            document.querySelectorAll('[data-db-parallax]').forEach(function (el) {
              var r = el.getBoundingClientRect();
              if (r.bottom < 0 || r.top > vh) return;
              var speed = parseFloat(el.getAttribute('data-db-parallax') || '0.08');
              var y = (r.top + r.height / 2 - vh / 2) * speed * -1;
              el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0) scale(1.12)';
            });
          };
          window.addEventListener('scroll', function () {
            if (!ticking) { ticking = true; requestAnimationFrame(update); }
          }, { passive: true });
          update();
        }
      }

      /* Magnetic buttons */
      if (!reduced && finePointer) {
        document.querySelectorAll('.db-btn, .db-colcard__arrow, .db-news__submit').forEach(function (btn) {
          if (btn.dataset.dbMagnet) return;
          if (btn.closest('.db-hero')) return; /* main hero CTAs stay put — hover states only */
          btn.dataset.dbMagnet = '1';
          btn.addEventListener('mousemove', function (e) {
            var r = btn.getBoundingClientRect();
            var x = (e.clientX - r.left - r.width / 2) * 0.25;
            var y = (e.clientY - r.top - r.height / 2) * 0.25;
            btn.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
          });
          btn.addEventListener('mouseleave', function () {
            btn.style.transform = '';
          });
        });
      }

      /* Marquee — no auto-motion; the band advances only as the page scrolls (wheel/scrollbar) */
      document.querySelectorAll('.db-marquee').forEach(function (marq) {
        if (marq.dataset.dbMarqBound) return;
        marq.dataset.dbMarqBound = '1';
        if (reduced) return; /* reduced-motion: leave the band static */
        var tracks = Array.prototype.slice.call(marq.querySelectorAll('.db-marquee__track'));
        if (!tracks.length) return;
        var data = tracks.map(function (track, ti) {
          var group = track.querySelector('.db-marquee__group');
          var items = group ? group.querySelectorAll('.db-marquee__item').length : 1;
          return { track: track, group: group, items: Math.max(items, 1), stagger: ti % 2 === 1, gw: 0 };
        });
        data.forEach(function (d) { d.track.style.animation = 'none'; }); /* kill the CSS auto-scroll; motion is now scroll-driven */
        var FACTOR = 0.6; /* same speed + direction for both rows so the stagger stays constant */
        var measure = function () {
          data.forEach(function (d) { if (d.group) d.gw = d.group.offsetWidth; });
        };
        var apply = function () {
          var sy = window.scrollY || window.pageYOffset || 0;
          data.forEach(function (d) {
            if (!d.gw) return;
            var ph = d.stagger ? (d.gw / d.items) * 0.3 : 0; /* offset 2nd row ~0.3 of a phrase so words interleave — not a clean column (avoids "tested underwater" sitting over "designed by divers") */
            var off = ((sy * FACTOR + ph) % d.gw + d.gw) % d.gw; /* 0..gw, seamless wrap */
            var tx = d.stagger ? (off - d.gw) : -off; /* the two rows travel in opposite directions */
            d.track.style.transform = 'translate3d(' + tx.toFixed(1) + 'px, 0, 0)';
          });
        };
        var ticking = false;
        var onScroll = function () {
          if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; apply(); }); }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', function () { measure(); apply(); });
        measure();
        apply();
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(function () { measure(); apply(); });
        }
      });

      /* Desktop mega menu — opens on HOVER, closes only when the pointer
         leaves the item + panel (closed <details> content cannot be shown by
         CSS alone, so JS toggles the [open] attribute; the open animation
         lives in db-mega.css). Mouse clicks on the label are neutralised so
         they can't stick the panel; keyboard (Enter/Tab) still works natively. */
      if (finePointer) {
        document.querySelectorAll('.header__inline-menu details.mega-menu').forEach(function (details) {
          if (details.dataset.dbHoverBound) return;
          details.dataset.dbHoverBound = '1';
          var summary = details.querySelector('summary');
          var li = details.closest('li') || details;
          var closeTimer = null;
          var openNow = function () {
            if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
            document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach(function (d) {
              if (d !== details) d.removeAttribute('open');
            });
            if (!details.hasAttribute('open')) details.setAttribute('open', '');
          };
          var closeSoon = function () {
            if (closeTimer) clearTimeout(closeTimer);
            closeTimer = setTimeout(function () {
              details.removeAttribute('open');
              closeTimer = null;
            }, 140); /* grace period for the summary → panel gap */
          };
          li.addEventListener('mouseenter', openNow);
          li.addEventListener('mouseleave', closeSoon);
          if (summary) {
            summary.addEventListener('mousedown', function (e) { e.preventDefault(); });
            summary.addEventListener('click', function (e) { if (e.detail !== 0) e.preventDefault(); });
          }
        });
      }

      /* Depth meter — a tiny diver descends the track as you scroll */
      var meter = document.querySelector('.db-depth');
      if (meter && !meter.dataset.dbBound) {
        meter.dataset.dbBound = '1';
        var fill = meter.querySelector('.db-depth__fill');
        var val = meter.querySelector('.db-depth__val');
        var diver = meter.querySelector('.db-depth__diver');
        var onScroll = function () {
          var max = document.documentElement.scrollHeight - window.innerHeight;
          var pp = max > 0 ? Math.min(window.scrollY / max, 1) : 0;
          if (fill) fill.style.height = (pp * 100).toFixed(1) + '%';
          if (diver) diver.style.top = (pp * 100).toFixed(1) + '%';
          if (val) val.textContent = '-' + Math.round(pp * 38) + 'm';
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      /* Scroll-pinned product showcase (turntable) */
      document.querySelectorAll('[data-db-showcase]').forEach(function (sec) {
        if (sec.dataset.dbShowBound) return;
        sec.dataset.dbShowBound = '1';
        var frames = sec.querySelectorAll('.db-showcase__frame');
        var callouts = sec.querySelectorAll('.db-showcase__callout');
        var cta = sec.querySelector('.db-showcase__cta');
        var depth = sec.querySelector('.db-showcase__depth');
        var prog = sec.querySelector('.db-showcase__progressfill');

        var revealShowcase = function () {
          if (frames[0]) frames[0].classList.add('is-on');
          callouts.forEach(function (c) { c.classList.add('is-on'); });
          if (cta) cta.classList.add('is-on');
        };
        if (reduced || window.innerWidth < 990) { revealShowcase(); return; }

        var showTicking = false;
        var upd = function () {
          showTicking = false;
          if (window.innerWidth < 990) { revealShowcase(); return; }
          var r = sec.getBoundingClientRect();
          var total = sec.offsetHeight - window.innerHeight;
          var pp = total > 0 ? Math.min(Math.max(-r.top / total, 0), 1) : 0;
          var idx = Math.min(Math.floor(pp * frames.length), frames.length - 1);
          frames.forEach(function (f, i) { f.classList.toggle('is-on', i === idx); });
          callouts.forEach(function (c) {
            var at = parseFloat(c.getAttribute('data-at') || '0');
            c.classList.toggle('is-on', pp >= at);
          });
          if (cta) cta.classList.toggle('is-on', pp >= 0.86);
          if (depth) depth.style.opacity = (pp * 0.92).toFixed(2);
          if (prog) prog.style.width = (pp * 100).toFixed(1) + '%';
        };
        window.addEventListener('scroll', function () {
          if (!showTicking) { showTicking = true; requestAnimationFrame(upd); }
        }, { passive: true });
        window.addEventListener('resize', upd);
        upd();
      });

      /* Featured rail — drag-to-scroll + keyboard */
      document.querySelectorAll('[data-db-rail]').forEach(function (rail) {
        if (rail.dataset.dbRailBound) return;
        rail.dataset.dbRailBound = '1';

        if (finePointer) {
          var down = false, startX = 0, startScroll = 0, moved = false;
          rail.addEventListener('pointerdown', function (e) {
            if (e.button !== 0) return;
            down = true; moved = false;
            startX = e.clientX; startScroll = rail.scrollLeft;
            rail.classList.add('is-dragging');
            try { rail.setPointerCapture(e.pointerId); } catch (err) {}
          });
          rail.addEventListener('pointermove', function (e) {
            if (!down) return;
            var dx = e.clientX - startX;
            if (Math.abs(dx) > 4) moved = true;
            rail.scrollLeft = startScroll - dx;
          });
          var end = function (e) {
            if (!down) return;
            down = false;
            rail.classList.remove('is-dragging');
            if (e && e.pointerId != null) { try { rail.releasePointerCapture(e.pointerId); } catch (err) {} }
          };
          rail.addEventListener('pointerup', end);
          rail.addEventListener('pointercancel', end);
          /* Swallow the click that ends a real drag so it doesn't navigate */
          rail.addEventListener('click', function (e) {
            if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
          }, true);
        }

        rail.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          var card = rail.querySelector('.db-featured__card');
          var step = card ? card.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
          rail.scrollBy({ left: e.key === 'ArrowRight' ? step : -step, behavior: reduced ? 'auto' : 'smooth' });
          e.preventDefault();
        });
      });

      /* Shoppable lookbook hotspots */
      var dbSpotSetOpen = function (spot, open) {
        spot.classList.toggle('is-open', open);
        var btn = spot.querySelector('.db-spot__dot');
        if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var card = spot.querySelector('.db-spot__card');
        if (card) {
          card.setAttribute('tabindex', open ? '0' : '-1');
          if (open) {
            /* Keep the card inside the stage (it clips via overflow:hidden) */
            card.style.setProperty('--db-card-shift', '0px');
            var stage = spot.closest('.db-lookbook__stage');
            if (stage) {
              var sr = stage.getBoundingClientRect();
              var cr = card.getBoundingClientRect();
              var pad = 20;
              var shift = 0;
              if (cr.right > sr.right - pad) shift = sr.right - pad - cr.right;
              else if (cr.left < sr.left + pad) shift = sr.left + pad - cr.left;
              if (shift !== 0) card.style.setProperty('--db-card-shift', shift.toFixed(1) + 'px');
            }
          }
        }
      };
      document.querySelectorAll('[data-db-lookbook]').forEach(function (sec) {
        if (sec.dataset.dbLookBound) return;
        sec.dataset.dbLookBound = '1';
        var spots = Array.prototype.slice.call(sec.querySelectorAll('.db-spot'));
        if (!spots.length) return;

        var closeAll = function (except) {
          spots.forEach(function (s) {
            if (s !== except) dbSpotSetOpen(s, false);
          });
        };

        spots.forEach(function (spot) {
          var btn = spot.querySelector('.db-spot__dot');
          if (!btn) return;
          btn.addEventListener('click', function () {
            var willOpen = !spot.classList.contains('is-open');
            closeAll(spot);
            dbSpotSetOpen(spot, willOpen);
          });
        });

        /* Escape closes and returns focus to the trigger dot */
        sec.addEventListener('keydown', function (e) {
          if (e.key !== 'Escape') return;
          var active = document.activeElement;
          var open = null;
          spots.forEach(function (s) { if (s.classList.contains('is-open')) open = s; });
          closeAll(null);
          if (open && (open.contains(active) || active === document.body)) {
            var d = open.querySelector('.db-spot__dot');
            if (d) d.focus();
          }
        });
      });
      /* One global outside-tap-to-close for all lookbook instances
         (pointerdown: iOS Safari does not deliver delegated clicks
         from non-interactive targets) */
      if (!document.documentElement.dataset.dbLookDocClose) {
        document.documentElement.dataset.dbLookDocClose = '1';
        var dbLookOutsideEvt = window.PointerEvent ? 'pointerdown' : 'click';
        document.addEventListener(dbLookOutsideEvt, function (e) {
          document.querySelectorAll('[data-db-lookbook] .db-spot.is-open').forEach(function (spot) {
            var owner = spot.closest('[data-db-lookbook]');
            if (owner && owner.contains(e.target)) return;
            dbSpotSetOpen(spot, false);
          });
        });
      }

      /* Print lab — hover/tap a row, the stage crossfades to that print */
      document.querySelectorAll('[data-db-printlab]').forEach(function (sec) {
        if (sec.dataset.dbPlabBound) return;
        sec.dataset.dbPlabBound = '1';
        var rows = Array.prototype.slice.call(sec.querySelectorAll('.db-plab__row'));
        var imgs = Array.prototype.slice.call(sec.querySelectorAll('.db-plab__img'));
        var ghost = sec.querySelector('[data-db-plab-ghost]');
        var cta = sec.querySelector('[data-db-plab-cta]');
        var stage = sec.querySelector('[data-db-plab-stage]');
        if (!rows.length) return;

        var stageLabel = sec.querySelector('[data-db-plab-stagelabel]');
        var activate = function (i) {
          rows.forEach(function (r, j) {
            var on = j === i;
            r.classList.toggle('is-active', on);
            r.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          imgs.forEach(function (im, j) {
            im.classList.toggle('is-active', j === i);
          });
          var url = rows[i].getAttribute('data-url') || '#';
          if (cta) cta.setAttribute('href', url);
          if (stage) stage.setAttribute('href', url);
          if (stageLabel) stageLabel.textContent = 'View ' + (rows[i].getAttribute('data-name') || 'product');
          if (ghost) ghost.textContent = (i < 9 ? '0' : '') + (i + 1);
        };

        rows.forEach(function (r, i) {
          r.addEventListener('click', function () {
            var url = r.getAttribute('data-url');
            if (r.classList.contains('is-active') && url && url !== '#') {
              window.location.href = url;
            } else {
              activate(i);
            }
          });
          if (finePointer) {
            r.addEventListener('mouseenter', function () { activate(i); });
          }
        });
        activate(0);
      });
    } catch (err) {
      /* Any failure during init must not strand reveal-gated content invisible */
      revealAllNow();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
